// @ngInject
export function sdFocusOut($parse: ng.IParseService): any {
  return ($scope: ng.IScope, $element: ng.IAugmentedJQuery, attr: any) => {
    let expression = attr.sdFocusOut;
    let condition = attr.sdFocusOutCondition;

    let onFocusOut = (event: FocusEvent) => {
      let containRelatedTarget = $element[0].contains(event.relatedTarget as Node);
      let containTarget = event.currentTarget != event.target && $element[0].contains(event.target as Node);
      if (containRelatedTarget || (event.relatedTarget == undefined && containTarget)) {
        return;
      }
      $scope.$evalAsync(expression);
    };

    let model = $parse(condition);
    $scope.$watch(model, (value) => {
      if (value == true) {
        $element[0].addEventListener("focusout", onFocusOut, true);
      } else {
        $element[0].removeEventListener("focusout", onFocusOut, true);
      }
    });
  };
}
